import Slider from '../../Molecules/Slider';
import CardVacancy, {
  Props as CardVacancyProps
} from '../../Molecules/CardVacancy';
import { Props as ButtonProps } from '../../Atoms/Button';

interface Props {
  vacancyList: CardVacancyProps[];
  utilityButton?: ButtonProps;
  navigationPosY?: 'bottom';
}

function CardVacancyCarousel({
  vacancyList,
  utilityButton,
  navigationPosY
}: Props) {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-10 py-7">
      <Slider
        navigationOutside
        navigationPosY={navigationPosY}
        utilityButton={utilityButton}
        slides={(vacancyList || []).map((vacancy) => (
          <CardVacancy
            key={vacancyList.indexOf(vacancy)}
            {...vacancy}
          />
        ))}
      />
    </div>
  );
}

export default CardVacancyCarousel;
